import dayjs, { Dayjs, ManipulateType, OpUnitType, QUnitType } from "dayjs";
import utc from "dayjs/plugin/utc";
import localeData from "dayjs/plugin/localeData";
import localizedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(utc);
import "dayjs/locale/es";
import "dayjs/locale/pt";
import weekday from "dayjs/plugin/weekday";
import { Hours } from "../../constants/model/models";
import { timezoneOffset } from "../../constants/env";

dayjs.extend(localeData);
dayjs.locale("pt");
dayjs.extend(weekday);
dayjs.extend(localizedFormat);

export function showShortAppointmentDateTime(date: string, locale: string) {
  dayjs.locale(locale);
  dayjs.extend(utc);

  const startDate = dayjs.utc(date);

  return showDate(startDate, "LLL");
}

export function showLocalizedDateTime(
  date: string,
  locale: string,
  format?: string
) {
  dayjs.locale(locale);
  return dayjs(date).format(format || "L LT");
}

export function showLocalizedDate(
  date: string,
  locale: string,
  format?: string
) {
  dayjs.locale(locale);
  return dayjs(date).format(format || "LL");
}

export function showLocalizedTime(date: string, locale: string) {
  dayjs.locale(locale);
  return dayjs(date).format("LT");
}

export function showDate(date: Dayjs, format?: string) {
  if (format) {
    return date.format(format);
  } else {
    return date.format("LL");
  }
}

export function addUnitWithStringDate(
  date: string,
  toAdd: number,
  unit: ManipulateType
) {
  const day = dayjs.utc(date);
  return day.add(toAdd, unit).format("YYYY-MM-DDTHH:mm");
}

export function timeIsBefore(time1: string, time2: string): boolean {
  return dayjs.utc(time1).isBefore(dayjs.utc(time2));
}

export function timeIsAfter(time1: string, time2: string): boolean {
  return dayjs.utc(time1).isAfter(dayjs.utc(time2));
}

export function extractHours(date: string): Hours {
  const start = date.split("T")[1];
  return {
    hour: +start.split(":")[0],
    minute: +start.split(":")[1],
  };
}

export function addZero(input: number) {
  if (input < 10) {
    return "0" + input;
  } else {
    return input.toString();
  }
}
